import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getClassNameGenerator } from '../../helper/className';

export const FormActions = ({ children, alignEnd, alignJustify }) => (
  <div className="form-actions">
    <div className="row">
      <div className={classNames('col-md-12', FormActions.getClassName('content'), {
        [FormActions.getClassName('content', true, 'align-end')]: alignEnd && !alignJustify,
        [FormActions.getClassName('content', true, 'align-justify')]: alignJustify,
      })} >
        {children}
      </div>
    </div>
  </div>
);

FormActions.className = 'form-actions';

FormActions.getClassName = getClassNameGenerator(FormActions.className);

FormActions.propTypes = {
  children: PropTypes.any,
  alignEnd: PropTypes.bool,
  alignJustify: PropTypes.bool
};

FormActions.defaultProps = {
  alignEnd: true
};
